// extracted by css-extract-rspack-plugin
export default {"root":"NboZ_4","heading":"tycvFd","footer":"oq3AK0"};